module.exports = __webpack_public_path__ + "img/newsImg.7bb4ba14.png";